import { CASE_INVESTIGATION_MANAGER_CONSTANTS as types } from '@store/constants';


const initialState = {
  config: {
    data: null,
    isLoading: false,
    isError: false,
    error: null
  },
  falcon: {
    caseInvestigations: {
      data: null,
      isLoading: false,
      isError: false,
      error: null,
      totalPages: 0
    },
    caseInvestigationDetails: {
      isLoading: false,
      isError: false,
      error: null,
      data: null
    }
  }
};


const caseInvestigationManagerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_CASE_INVESTIGATION_MANAGER_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: true,
          isError: false,
          error: null,
          data: null
        }
      };

    case types.GET_CASE_INVESTIGATION_MANAGER_CONFIG_SUCCESS:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };

    case types.GET_CASE_INVESTIGATION_MANAGER_CONFIG_FAILURE:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: false,
          isError: true,
          error: payload,
          data: null
        }
      };

    case types.GETTING_CASE_INVESTIGATIONS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_CASE_INVESTIGATIONS_SUCCESS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_CASE_INVESTIGATIONS_FAILURE:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            data: null,
            error: payload,
            isError: true
          }
        }
      };

    case types.GETTING_CASE_INVESTIGATION_DETAILS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigationDetails: {
            ...state.falcon.caseInvestigationDetails,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_CASE_INVESTIGATION_DETAILS_SUCCESS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigationDetails: {
            ...state.falcon.caseInvestigationDetails,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_CASE_INVESTIGATION_DETAILS_FAILURE:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigationDetails: {
            ...state.falcon.caseInvestigationDetails,
            isLoading: false,
            data: null,
            error: payload,
            isError: true
          }
        }
      };

    case types.CREATING_NEW_CASE_INVESTIGATION:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: true,
            error: null,
            isError: false
          }
        }
      };

    case types.CREATE_NEW_CASE_INVESTIGATION_SUCCESS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            error: null,
            isError: false
          }
        }
      };

    case types.CREATE_NEW_CASE_INVESTIGATION_FAILURE:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            error: payload,
            isError: true
          }
        }
      };

    case types.GETTING_FALCON_CASE_INVESTIGATIONS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_FALCON_CASE_INVESTIGATIONS_SUCCESS:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_FALCON_CASE_INVESTIGATIONS_FAILURE:
      return {
        ...state,
        falcon: {
          ...state.falcon,
          caseInvestigations: {
            ...state.falcon.caseInvestigations,
            isLoading: false,
            data: null,
            error: payload,
            isError: true
          }
        }
      };

    case types.SET_CASE_INVESTIGATION_MANAGER_TO_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};

export default caseInvestigationManagerReducer;
